import { ReactComponent as WilliamsLogo } from '../icons/williams_logo.svg'
import { ReactComponent as HDCLogo } from '../icons/hdc_logo.svg'
import { ReactComponent as OvativeLogo } from '../icons/ovative_logo.svg'
import { ReactComponent as ScottishWidowsLogo } from '../icons/scottish_widows_logo.svg'
import { ReactComponent as SalonLoftsLogo } from '../icons/salon_lofts_logo.svg'


const customerSpecs = {
    f1_williams: <WilliamsLogo />,
    williams: <WilliamsLogo />,
    HDC: <HDCLogo />,
    ovative: <OvativeLogo />,
    scottish_widows: <ScottishWidowsLogo />,
    salon_Lofts: <SalonLoftsLogo />
}


export default customerSpecs;